import { useRef } from 'react';

/**
 * Lets an async result land only if nothing newer has started since: `start()`
 * stamps a request, `invalidate()` retires every stamp so far, and
 * `isLatest(stamp)` says whether a result still answers the current inputs.
 *
 * For the import dialogs, where a preview or a file read that finishes after
 * the reader changed the division, the branch or the files would otherwise put
 * back what they no longer describe.
 */
export function useLatestOnly() {
  const latest = useRef(0);
  return {
    start: () => {
      latest.current += 1;
      return latest.current;
    },
    invalidate: () => {
      latest.current += 1;
    },
    isLatest: (stamp: number) => stamp === latest.current,
  };
}
